import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getApexChartOptions } from "../../common/utils/apex-chart-options";

function ApexChart(props) {
    const [graphData, setGraphData] = useState(() => {
        return {
            name: props.name,
            data: props && props.dataList ? [...props.dataList] : []
        }
    });

    useEffect(() => {
        if (props && props.dataList && props.dataList.length > 0) {

            let updatedData = [...props.dataList];

            if (updatedData.length > 700) updatedData.splice(0, 200);
            // console.log("updatedData: " + JSON.stringify(updatedData));

            setGraphData({
                name: props.name,
                data: updatedData
            })
        }
    }, [props]);

    return (
        <ReactApexChart type="line" id={props.name} key={props.name} options={getApexChartOptions(props)} series={[graphData]} width={props.width} height={props.height} />
    );
};

export default ApexChart;

